import { Component, OnInit } from '@angular/core';
import {TipoCosmetico} from '../../../models/tipo-cosmetico.model';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  selector: 'app-lista-productos-cosmeticos',
  templateUrl: './lista-productos-cosmeticos.component.html',
  styleUrls: ['./lista-productos-cosmeticos.component.css']
})
export class ListaProductosCosmeticosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Productos cosméticos e higiénicos',
      routerLink: '/cosmeticoshigienicos'
    }
  ];

  tipos: TipoCosmetico[];
  loading = false;

  constructor(private catalogosService: CatalogosService) { }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposCosmeticos().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }

}
